import { HistoricalTrade, HistoricalTradeResponse, TradeMatch, TradeMatchPosting, isConvertedTradeMatchPosting, isTradeMatchPosting, LedgerProcessType } from "swan-public-api-client";

export interface TradeHistoryGridRow extends HistoricalTrade {
  Pnl?: number;
  PnlCurrencyId?: number;
  OpeningOrClosing: OpeningOrClosing;
}

export enum OpeningOrClosing {
  opening,
  closing
}

export function convertToTradeHistoryGridRows(history: HistoricalTradeResponse | undefined, baseCurrencyId: number): TradeHistoryGridRow[] {
  if (history === undefined) {
    return [];
  }

  const openingTradeMatchesByTrade = new Map<string, TradeMatch[]>();
  const closingTradeMatchesByTrade = new Map<string, TradeMatch[]>();
  history.TradeMatches.forEach(tradeMatch => {
    if (!openingTradeMatchesByTrade.has(tradeMatch.OpeningTradeKey.Key)) {
      openingTradeMatchesByTrade.set(tradeMatch.OpeningTradeKey.Key, []);
    }
    const tradeMatchesForOpeningTrade = openingTradeMatchesByTrade.get(tradeMatch.OpeningTradeKey.Key)!;
    tradeMatchesForOpeningTrade.push(tradeMatch);

    if (!closingTradeMatchesByTrade.has(tradeMatch.ClosingTradeKey.Key)) {
      closingTradeMatchesByTrade.set(tradeMatch.ClosingTradeKey.Key, []);
    }
    const tradeMatchesForClosingTrade = closingTradeMatchesByTrade.get(tradeMatch.ClosingTradeKey.Key)!;
    tradeMatchesForClosingTrade.push(tradeMatch);
  });

  const tradeMatchPostings = new Map<string, TradeMatchPosting>();
  history.Postings.forEach(x => {
    if (
      (isConvertedTradeMatchPosting(x) || isTradeMatchPosting(x))
      && x.PostingType.Key === LedgerProcessType.Trade) {
      tradeMatchPostings.set(x.TradeMatchKey, x);
    }
  });

  return history.Trades.map(trade => {
    const closingTradeMatches = closingTradeMatchesByTrade.get(trade.InstructionKey.Key);
    if (closingTradeMatches === undefined) {
      const openingTradeRow: TradeHistoryGridRow = {
        ...trade!,
        Pnl: undefined,
        PnlCurrencyId: undefined,
        OpeningOrClosing: OpeningOrClosing.opening
      };
      return openingTradeRow;
    }

    const postings = closingTradeMatches.map(tradeMatch => tradeMatchPostings.get(tradeMatch.Key)!);
    const postingsAreAllTheSameCurrency = postings.every(isConvertedTradeMatchPosting) || postings.every(posting => !isConvertedTradeMatchPosting(posting));
    const pnl = postingsAreAllTheSameCurrency // Can't add postings of different currencies
      ? postings.reduce((accumulator, posting) => accumulator + posting.Amount, 0)
      : undefined;
    const pnlCurrencyId = postingsAreAllTheSameCurrency
      ? postings.every(isConvertedTradeMatchPosting)
        ? baseCurrencyId
        : trade.CurrencyId
      : undefined;

    const tradeRow: TradeHistoryGridRow = {
      ...trade!,
      Pnl: pnl,
      PnlCurrencyId: pnlCurrencyId,
      OpeningOrClosing: OpeningOrClosing.closing
    };
    return tradeRow;
  });
}
